import React from 'react';
import { Trophy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';

function rankTone(rank) {
  if (rank === 1) return 'bg-brand-gold text-white';
  if (rank === 2) return 'bg-gray-400 text-white';
  if (rank === 3) return 'bg-amber-700 text-white';
  return 'bg-red-50 text-brand-red';
}

export function LeaderboardTable({ items }) {
  if (!items.length) {
    return (
      <p className="py-8 text-center text-sm text-gray-500">
        ยังไม่มีข้อมูลอันดับ
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[520px] text-left text-sm">
        <thead>
          <tr className="border-b border-red-100 text-xs uppercase tracking-wide text-gray-500">
            <th className="px-3 py-3 font-semibold">อันดับ</th>
            <th className="px-3 py-3 font-semibold">Username</th>
            <th className="px-3 py-3 text-right font-semibold">ยอดแทง</th>
            <th className="px-3 py-3 text-right font-semibold">ยอดถูก</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <tr
              key={`${row.userId}-${row.rank}`}
              className="border-b border-red-50 last:border-0"
            >
              <td className="px-3 py-3">
                <span
                  className={`inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${rankTone(row.rank)}`}
                >
                  {row.rank}
                </span>
              </td>
              <td className="px-3 py-3 font-semibold text-gray-800">
                {row.username}
              </td>
              <td className="px-3 py-3 text-right font-medium text-gray-700">
                {formatMoney(row.totalBet)}
              </td>
              <td className="px-3 py-3 text-right font-semibold text-brand-red">
                {formatMoney(row.totalWin)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function LeaderboardPagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-4 flex items-center justify-between gap-3">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className="rounded-lg border border-red-100 px-3 py-2 text-sm font-semibold text-brand-red transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        ก่อนหน้า
      </button>
      <p className="text-sm text-gray-600">
        หน้า {page} / {totalPages}
      </p>
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="rounded-lg border border-red-100 px-3 py-2 text-sm font-semibold text-brand-red transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        ถัดไป
      </button>
    </div>
  );
}

export function LeaderboardCard({ items, page, totalPages, onPageChange }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Trophy className="h-5 w-5" />
          อันดับผู้เล่น
        </CardTitle>
      </CardHeader>
      <CardContent>
        <LeaderboardTable items={items} />
        <LeaderboardPagination
          page={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </CardContent>
    </Card>
  );
}
